import { OrderSummaryCard } from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { useGetPendingOrderQuery } from "../../../common/api/refurbished";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";
import { useCheckoutFormContext } from "../CheckoutFormContext";
import { useCheckoutLabels } from "../hooks/useCheckoutLabels";

export const CheckoutOrderSummary = (): JSX.Element | null => {
    const labels = useCheckoutLabels();
    const { t } = useStringTranslation();
    const { isValid, isSubmitting, submitError, handleSubmit } =
        useCheckoutFormContext();
    const { data: userData } = useGetUserInfoQuery();
    const { data: pendingOrderResponse } = useGetPendingOrderQuery();
    const activeLanguage = userData?.activeLanguage ?? null;

    const pendingOrder = pendingOrderResponse?.data ?? null;

    if (!pendingOrder?.order_lines.length || !activeLanguage?.localeCode) {
        return null;
    }

    const itemsLabel = t("cart-order-summary-items").replace(
        "{count}",
        String(pendingOrder.order_lines.length),
    );

    return (
        <div className="p-checkout-page__summary">
            <OrderSummaryCard
                itemsCount={pendingOrder.order_lines.length}
                itemsTotal={pendingOrder.items_total}
                discount={pendingOrder.discount_total ?? undefined}
                total={pendingOrder.total}
                title={labels.orderSummaryTitle}
                itemsLabel={itemsLabel}
                discountLabel={labels.orderSummaryDiscount}
                totalLabel={labels.orderSummaryTotal}
                checkoutLabel={labels.placeOrder}
                disclaimer={labels.orderDisclaimer}
                onCheckout={() => void handleSubmit()}
                checkoutDisabled={!isValid}
                isCheckoutLoading={isSubmitting}
            />
            {submitError && (
                <p className="p-checkout-page__submit-error" role="alert">
                    {submitError}
                </p>
            )}
        </div>
    );
};
